import { Typography } from 'antd'
import { SubIcon } from 'components/subIcon'
import moment from 'moment'
import React from 'react'
import { Api } from 'services'
import UserAvatar from 'components/userAvatar'
import Online from "../../../../Assets/schedule/online.svg"
import Offline from "../../../../Assets/schedule/offline.svg"
import OtherColor from "../../../../Assets/schedule/other_color.svg"
import Conference from "../../../../Assets/schedule/confrence.svg"
const Hat = require("../../../../Assets/scheduleAttendance/Group 11910.svg").default
const Clock = require("../../../../Assets/scheduleAttendance/Group 12077.svg").default

const SubjectCardDisplay = ({ data }) => {
  console.log(data, 'data in subject card')
  let startTime = moment(data?.startTime, ["h:mm A"]).format('HH:mm A')
  let endTime = moment(data?.endTime, ["h:mm A"]).format('HH:mm A')

  const batchName = data?.standards?.length ? data?.standards
    .filter(item => (item?.std && item?.std !== 'undefined') || (item?.section && item?.section !== 'undefined'))
    .map((item) => {
      const std = item?.std && item?.std !== 'undefined' ? item.std : '';
      const section = item?.section && item?.section !== 'undefined' ? item.section : '';
      const separator = std && section ? '-' : '';
      return `${std}${separator}${section}`;
    }).join(', ') : ''

  return (
    <div className='attendance-subjectCard'>
      <div>
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          {data?.subject?.icon ?
            <img style={{ height: '60px', width: '60px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} src={`${Api._s3_url}${data?.subject?.icon}`} alt={data?.subject?.name || 'Subject'}></img>
            :
            <div style={{ flexShrink: 0 }}>
              <SubIcon name={data?.subject?.name} size={60} />
            </div>
          }
          <div style={{ paddingLeft: '15px', flex: 1, minWidth: 0 }}>
            <div style={{ marginBottom: '8px' }}>
              {data?.mode?.toLowerCase() === 'broadcast' || data?.mode?.toLowerCase() === 'online' ? (
                  <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FFF9', border: '1px solid #C8EEE4', borderRadius: '8px', padding: '3px 7px'}}>
                      <img src={Online} alt="Online" style={{ height:"16px", width:"16px" }} />
                      <Typography.Text style={{ fontSize: '10px', color: '#00A566', marginLeft: '5px', textTransform: 'uppercase', fontWeight: 'bold' }}>{data?.mode}</Typography.Text>
                  </div>
              ) : data?.mode?.toLowerCase() === 'conference' ? (
                  <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '3px 7px' }}>
                      <img src={Conference} alt="Conference" style={{ height:"16px", width:"16px" }} />
                      <Typography.Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 'bold' }}>{data?.mode}</Typography.Text>
                  </div>
              ) : data?.mode?.toLowerCase() === 'others' ? (
                  <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
                      <img src={OtherColor} alt="Other" style={{ height:"16px", width:"16px" }} />
                      <Typography.Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px', textTransform: 'uppercase', fontWeight: 'bold' }}>{data?.mode}</Typography.Text>
                  </div>
              ) : data?.mode?.toLowerCase() === 'hybrid' ? (
                  <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF0F6', border: '1px solid #FFD6E7', borderRadius: '8px', padding: '3px 7px' }}>
                      <img src={Online} alt="Hybrid" style={{ height:"16px", width:"16px" }} />
                      <Typography.Text style={{ fontSize: '10px', color: '#EB2F96', marginLeft: '5px', textTransform: 'uppercase', fontWeight: 'bold' }}>{data?.mode}</Typography.Text>
                  </div>
              ) : (
                  <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFD8DA', border: '1px solid #FFF5F6', borderRadius: '8px', padding: '3px 7px' }}>
                      <img src={Offline} alt="Offline" style={{ height:"16px", width:"16px" }} />
                      <Typography.Text style={{ fontSize: '10px', color: '#FF414D', marginLeft: '5px', textTransform: 'uppercase', fontWeight: 'bold' }}>{data?.mode || 'OFFLINE'}</Typography.Text>
                  </div>
              )}
            </div>
            <div style={{ width: '100%', minWidth: 0 }}>
              <Typography.Text ellipsis={{ tooltip: data?.subject?.name }} style={{ fontWeight: 'bold', paddingTop: '5px', width: '100%', display: 'block' }}>{data?.subject?.name}</Typography.Text>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '15px', fontSize: '13px' }}>
          <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: 1, marginRight: '10px' }}>
            <img src={Hat} alt="Hat Icon" style={{ marginRight: '6px', flexShrink: 0 }} />
            <Typography.Text ellipsis={{ tooltip: batchName }} style={{ fontSize: '13px', display: 'block', width: '100%' }}>
              {batchName}
            </Typography.Text>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, fontSize: '13px' }}>
            <img src={Clock} alt="Clock Icon" style={{ marginRight: '6px' }} />
            <span>{startTime} - {endTime}</span>
          </div>
        </div>
        <div style={{ paddingTop: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
              <UserAvatar
                size={20}
                shape="circle"
                name={data?.teacher?.name}
                img={data?.teacher?.image && data?.teacher?.image !== 'default.png' ? `${Api._s3_url}${data?.teacher?.image}` : ''}
              />
            </div>
            <div style={{ paddingLeft: '8px', minWidth: 0, flex: 1 }}>
              <Typography.Text ellipsis={{ tooltip: data?.teacher?.name }} style={{ fontSize: '13px', display: 'block', width: '100%' }}>
                {data?.teacher?.name}
              </Typography.Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubjectCardDisplay